import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2021. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import React from 'react';
import { Grid, Column, IllustratedMessage } from '@govhhs/govhhs-design-system-react';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import RouterLink from '../router/RouterLink';
import translations from './IEGPageNotAvailableMessages';
import { ID } from './constants';
import PATHS from '../router/Paths';
/**
 * Page to be displayed when an IEG Page is no longer available.
 *
 * @memberof ErrorBoundaryComponent
 */

var IEGPageNotAvailable = function IEGPageNotAvailable(props) {
  var intl = props.intl;
  var refreshPageLink = /*#__PURE__*/React.createElement(RouterLink, {
    onClick: function onClick(e) {
      e.preventDefault(); // refresh current page from link

      window.location.reload();
    },
    to: PATHS.HOME
  }, intl.formatMessage(translations.error400PageNotAvailableResume));
  return /*#__PURE__*/React.createElement(Grid, {
    id: ID.IEG_PAGE_NOT_AVAILABLE_ID
  }, /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement("div", {
    align: "center"
  }, /*#__PURE__*/React.createElement(Grid, null, /*#__PURE__*/React.createElement(Column, {
    className: "wds-u-mv--xx-large",
    width: "3"
  }), /*#__PURE__*/React.createElement(Column, {
    breakRow: true,
    className: "wds-u-mv--xx-large",
    width: "6"
  }, /*#__PURE__*/React.createElement(IllustratedMessage, {
    message: /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, translations.error400PageNotAvailableDescription, {
      values: {
        refreshPageLink: refreshPageLink
      }
    }))),
    name: "brokenPage",
    title: intl.formatMessage(translations.error400PageNotAvailableTitle)
  }))))));
};

IEGPageNotAvailable.propTypes = process.env.NODE_ENV !== "production" ? {
  intl: intlShape.isRequired
} : {};
export default injectIntl(IEGPageNotAvailable);